import { render, staticRenderFns } from "./GDPRBanner.vue?vue&type=template&id=924753fe&scoped=true&"
import script from "./GDPRBanner.vue?vue&type=script&lang=js&"
export * from "./GDPRBanner.vue?vue&type=script&lang=js&"
import style0 from "./GDPRBanner.vue?vue&type=style&index=0&id=924753fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "924753fe",
  null
  
)

export default component.exports